export default (
  stroke = '#1043E7'
) => `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.44 0H16.56V14.5236L6.29025 4.25382L4.25378 6.29029L14.5235 16.56H0V19.44H14.5235L4.25382 29.7097L6.29029 31.7462L16.56 21.4765V36H19.44V21.4765L29.7096 31.7461L31.7461 29.7097L21.4764 19.44H36V16.56H21.4765L31.7461 6.29033L29.7097 4.25386L19.44 14.5235V0Z" fill="${stroke}"/>
</svg>
`;
